module.exports = __webpack_public_path__ + "img/san-eduardo.3afb5e05.jpg";